import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row w-full mtop-10" }
const _hoisted_6 = { class: "col-0-8 colend mright-04" }
const _hoisted_7 = { class: "main-m font-m" }
const _hoisted_8 = { class: "row w-full mtop-10" }
const _hoisted_9 = { class: "col-0-8 colend mright-04" }
const _hoisted_10 = { class: "main-m font-m" }
const _hoisted_11 = { class: "row w-full mtop-10" }
const _hoisted_12 = { class: "col-0-8 colend mright-04" }
const _hoisted_13 = { class: "main-m font-m" }
const _hoisted_14 = { class: "mtop-10" }
const _hoisted_15 = { class: "row w-full mtop-10" }
const _hoisted_16 = { class: "col-0-8 colend mright-04" }
const _hoisted_17 = { class: "main-m font-m" }
const _hoisted_18 = { class: "row w-full mtop-10" }
const _hoisted_19 = { class: "col-0-8 colend mright-04" }
const _hoisted_20 = { class: "main-m font-m" }
const _hoisted_21 = { class: "col-0-6 colend mright-04 mleft-04" }
const _hoisted_22 = { class: "main-m font-m" }
const _hoisted_23 = { class: "row w-full mtop-10" }
const _hoisted_24 = { class: "col-0-8 colend mright-04" }
const _hoisted_25 = { class: "main-m font-m" }

import { ref, computed, onMounted } from 'vue';
import { useAppUserStore } from '@/stores/appUser'
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import { ApiError, ButtonAction, IsoCode, ItemButtonGroup, ItemSelect, ItemSelectPhone } from '@/models/share.model';
import { CreateThirdPersonRequest, ThirdPersonApi } from '@/apiGenerate/medserver';
import { COUNTRY_LIST, PHONE_PREFIX_LIST } from '@/functions/geo';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import EsSelectCountry from '@/components/esSelectCountry.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'addThirdPersonForm',
  emits: ['afterPersonCreated'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const { t } = useI18n();
const toast = useToast();

const thirdPersonApi = new ThirdPersonApi(medServerApiConfig);

const countries = ref<ItemSelect[]>([]);
const phoneCountries = ref<ItemSelect[]>([]);

const itemButtonGroup = ref<ItemButtonGroup[]>([
  {
    codeAction: ButtonAction.ADD,
    icon: 'person',
    pathIcon: 'shareIcons',
    method: async () => await confirmFormModal()
  }
]); 

const createThirdPersonRequest = ref<CreateThirdPersonRequest>({
  firstname: undefined,
  lastname: undefined,
  address: {
    street: undefined,
    postalCode: undefined,
    locality: undefined,
    isoCode: undefined
  },
  phone: {
    phoneNumber: undefined,
    phonePrefix: undefined,
  }
})

const emits = __emit;

const countryToItemSelect = (country: {isoCode: string; term: string}): ItemSelect => {
  return {
    id: country.isoCode,
    label: country.term,
  }
}

const getCountries = () => {
  countries.value = COUNTRY_LIST.map((country: {isoCode: string; term: string}) => {
    return countryToItemSelect(country);
  });
}

const phoneCountryToItemSelect = (phone: {prefix: string, isoCode: string; term: string}): ItemSelectPhone => {
  return {
    id: phone.isoCode,
    label: `${phone.term}`, 
    prefix: `+${phone.prefix}` 
  }
}

const getPhoneCountries = () => {
  phoneCountries.value = PHONE_PREFIX_LIST.map((phone: {prefix: string, isoCode: string; term: string}) => {
    return phoneCountryToItemSelect(phone);
  });
}

const currInstituteName = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "Institut ..."}
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole
  return currentIwr.instituteShortName
});

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {
    return "";
  }
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const closeFormModal = () => {
  emits('afterPersonCreated');
}

const checkAddressValid = (createThirdPersonRequest : CreateThirdPersonRequest) => {
  if(createThirdPersonRequest.address && !createThirdPersonRequest.address.isoCode){
    createThirdPersonRequest.address.isoCode = IsoCode.LU;
    if(!createThirdPersonRequest.address.postalCode && 
      !createThirdPersonRequest.address.street && 
      !createThirdPersonRequest.address.locality ){
      createThirdPersonRequest.address = null;
    }
  }
}

const checkPhoneValid = (createThirdPersonRequest : CreateThirdPersonRequest) => {
  if(createThirdPersonRequest.phone && !createThirdPersonRequest.phone.phonePrefix){
    createThirdPersonRequest.phone.phonePrefix = IsoCode.LU;
  }
  if(!createThirdPersonRequest.phone.phoneNumber && createThirdPersonRequest.phone.phonePrefix){
      createThirdPersonRequest.phone = null;
  }
}

const confirmFormModal = async () => {
  if (currInstituteUuid.value) {
    
    //DEEP COPY
    let request = JSON.parse(JSON.stringify(createThirdPersonRequest.value));
    checkAddressValid(request);
    checkPhoneValid(request);
    await thirdPersonApi.createThirdPersonHealthPro({instituteId: currInstituteUuid.value, createThirdPersonRequest: request}).then(() => {
      toastSuccess(toast, {
          summary: t('common.toast.success.add'),
          detail:  t('thirdPerson.create.message.success.add')
      });
      emits('afterPersonCreated');
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });

        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
    });
  }
}

onMounted(() => {
  getCountries();
  getPhoneCountries();
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_es_modal_header, {
          header: _unref(t)('thirdPerson.create.title.pro', {name: currInstituteName.value})
        }, null, 8, ["header"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(_unref(t)('thirdPerson.create.form.lastname')), 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
              ])
            ]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.lastname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createThirdPersonRequest.value.lastname) = $event)),
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('thirdPerson.create.form.firstname')), 1)
            ]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.firstname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createThirdPersonRequest.value.firstname) = $event)),
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('thirdPerson.create.form.favoritePhone')), 1)
            ]),
            _createVNode(EsSelectCountry, {
              modelValue: createThirdPersonRequest.value.phone.phonePrefix,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createThirdPersonRequest.value.phone.phonePrefix) = $event)),
              countries: phoneCountries.value,
              "show-prefix": true,
              default: true,
              onChangeSelect: _cache[3] || (_cache[3] = currentCountry => createThirdPersonRequest.value.phone.phonePrefix = currentCountry)
            }, null, 8, ["modelValue", "countries"]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.phone.phoneNumber,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createThirdPersonRequest.value.phone.phoneNumber) = $event)),
              class: "w-full mleft-02"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("h4", _hoisted_14, _toDisplayString(_unref(t)('thirdPerson.create.form.address')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('thirdPerson.create.form.street')), 1)
            ]),
            _createVNode(_unref(InputText), {
              class: "w-full",
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.address.street,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createThirdPersonRequest.value.address.street) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('thirdPerson.create.form.postalCode')), 1)
            ]),
            _createVNode(_unref(InputText), {
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.address.postalCode,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createThirdPersonRequest.value.address.postalCode) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('thirdPerson.create.form.locality')), 1)
            ]),
            _createVNode(_unref(InputText), {
              class: "w-full",
              type: "text",
              size: "small",
              modelValue: createThirdPersonRequest.value.address.locality,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createThirdPersonRequest.value.address.locality) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('thirdPerson.create.form.country')), 1)
            ]),
            _createVNode(EsSelectCountry, {
              modelValue: createThirdPersonRequest.value.address.isoCode,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createThirdPersonRequest.value.address.isoCode) = $event)),
              countries: countries.value,
              default: true,
              onChangeSelect: _cache[9] || (_cache[9] = currentCountry => createThirdPersonRequest.value.address.isoCode = currentCountry)
            }, null, 8, ["modelValue", "countries"])
          ])
        ]),
        _createVNode(_component_es_modal_footer, {
          onModalCancel: closeFormModal,
          "item-button-group": itemButtonGroup.value
        }, null, 8, ["item-button-group"])
      ], 512)
    ])
  ]))
}
}

})